module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-list/customer-list.component.css
// module id = ./src/app/customer-list/customer-list.component.css
// module chunks = main